// UpdateFormContext.tsx
import React, { createContext, useContext, useState, ReactNode } from "react";

// 1️⃣ Define the shape of your context
interface UpdateFormContextType {
  countData: any;
  setCountData: (newData: any) => void;
}

// 2️⃣ Create the context with default undefined
const UpdateFormContext = createContext<UpdateFormContextType | undefined>(
  undefined,
);

// 3️⃣ Create the provider
export const CountDataProvider = ({ children }: { children: ReactNode }) => {
  const [countData, setMyData] = useState<any>(null);

  const setCountData = (newData: any) => {
    setMyData(newData);
  };

  return (
    <UpdateFormContext.Provider value={{ countData, setCountData }}>
      {children}
    </UpdateFormContext.Provider>
  );
};

// 4️⃣ Create custom hook
export const useCountData = (): UpdateFormContextType => {
  const context = useContext(UpdateFormContext);
  if (!context) {
    throw new Error("useUpdateForm must be used within an UpdateFormProvider");
  }
  return context;
};
